import { Link } from "gatsby"
import React from "react"
import { useUsersGraphql } from "../hooks/use-users-graphql"
import CategoriesWidget from "./categories-widget"
import RecentPostsWidget from "./recent-posts-widget"

const Footer = props => {
  const { users } = useUsersGraphql()

  return (
    <footer id="colophon" className="site-footer">
      <aside className="widget-area" aria-label="Footer">
        <div className="widget-column footer-widget-1">
          <RecentPostsWidget />
          <CategoriesWidget />
        </div>
      </aside>
      <div className="show_desktop" style={{ display: "flex" }}>
        <div className="site-footer-section" style={{ paddingTop: "20px" }}>
          <div
            className="div-footer-loading"
            style={{ display: "flex", marginLeft: "20px" }}
          >
            <img
              className="img-footer-loading"
              style={{
                margin: "auto",
                verticalAlign: "middle",
                objectPosition: "center",
                maxHeight: "100px",
                display: "inline-block",
                objectFit: "contain",
                width: "100%",
                height: "37px",
              }}
              src={"/img/logo_startupitalia.png"}
              alt={"Home"}
            />
          </div>
          <div
            style={{
              height: "28.8px",
              width: "194px",
              fontFamily: "urw-din",
              fontSize: "12px",
              fontWeight: "500",
              letterSpacing: "0.48px",
              lineHeight: "12px",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            Il magazine dell'innovazione e delle startup italiane
          </div>
          <div
            style={{
              display: "flex",
              height: "50px",
              textAlign: "center",
              marginTop: "30px",
              marginBottom: "30px",
            }}
          >
            <div
              style={{
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <a
                className="resp-sharing-button__link"
                href={"https://www.facebook.com/StartupItalia.eu/"}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <div className="resp-sharing-button resp-sharing-button--facebook resp-sharing-button--medium">
                  <div
                    aria-hidden="true"
                    className="resp-sharing-button__icon resp-sharing-button__icon--solid"
                  >
                    <img alt="" src={"/img/facebook@2x-red.png"} />
                  </div>
                </div>
              </a>

              <a
                className="resp-sharing-button__link"
                href={"https://twitter.com/startup_italia"}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter"
              >
                <div className="resp-sharing-button resp-sharing-button--twitter resp-sharing-button--medium">
                  <div
                    aria-hidden="true"
                    className="resp-sharing-button__icon resp-sharing-button__icon--solid"
                  >
                    <img alt="" src={"/img/twitter@2x-red.png"} />
                  </div>
                </div>
              </a>

              <a
                className="resp-sharing-button__link"
                href={"https://www.instagram.com/startupitalia/"}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <div className="resp-sharing-button resp-sharing-button--instagram resp-sharing-button--medium">
                  <div
                    aria-hidden="true"
                    className="resp-sharing-button__icon resp-sharing-button__icon--solid"
                  >
                    <img alt="" src={"/img/instagram@2x-red.png"} />
                  </div>
                </div>
              </a>

              <a
                className="resp-sharing-button__link"
                href={
                  "https://www.linkedin.com/company/startupitalia-pushtostart/"
                }
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Linkedin"
              >
                <div className="resp-sharing-button resp-sharing-button--linkedin resp-sharing-button--medium">
                  <div
                    aria-hidden="true"
                    className="resp-sharing-button__icon resp-sharing-button__icon--solid"
                  >
                    <img alt="" src={"/img/linkedin@2x-red.png"} />
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>

        <div style={{ paddingLeft: "4rem" }} className="site-footer-section">
          <div>
            <h2 style={{ fontSize: "17px" }}>&nbsp; {/* Topic */}</h2>
          </div>
          <Link to="/life/" style={{ color: "inherit" }}>
            <div style={{ fontSize: "14px" }}>Life</div>
          </Link>
          <Link to="/valoreresponsabile/" style={{ color: "inherit" }}>
            <div style={{ fontSize: "14px" }}>Valore Responsabile</div>
          </Link>
          <Link to="/smartmoney/" style={{ color: "inherit" }}>
            <div style={{ fontSize: "14px" }}>Smart Money</div>
          </Link>
        </div>

        <div style={{ paddingLeft: "4rem" }} className="site-footer-section">
          <div>
            <h2 style={{ fontSize: "17px" }}>&nbsp; {/* Canali */}</h2>
          </div>
          <Link to="/tech/" style={{ color: "inherit" }}>
            <div style={{ fontSize: "14px" }}>Tech</div>
          </Link>
          <Link to="/economy/" style={{ color: "inherit" }}>
            <div style={{ fontSize: "14px" }}>Economy</div>
          </Link>
          <Link to="/education/" style={{ color: "inherit" }}>
            <div style={{ fontSize: "14px" }}>Education</div>
          </Link>
          <Link to="/lifestyle/" style={{ color: "inherit" }}>
            <div style={{ fontSize: "14px" }}>Lifestyle</div>
          </Link>
          <Link to="/startup/" style={{ color: "inherit" }}>
            <div style={{ fontSize: "14px" }}>Startup</div>
          </Link>
          <Link to="/impact/" style={{ color: "inherit" }}>
            <div style={{ fontSize: "14px" }}>Impact</div>
          </Link>
        </div>

        <div style={{ paddingLeft: "4rem" }} className="site-footer-section">
          <div>
            <h2 style={{ fontSize: "17px" }}>StartupItalia</h2>
          </div>
          <Link to="/about-us/" style={{ color: "inherit" }}>
            <div style={{ fontSize: "14px" }}>Advisory Board</div>
          </Link>
          <a
            href={"https://investor.startupitalia.eu/"}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "inherit" }}
          >
            <div style={{ fontSize: "14px" }}>Area Investor</div>
          </a>
          <Link
            to="https://startupitaliaopensummit.eu/"
            target="_blank"
            style={{ color: "inherit" }}
          >
            <div style={{ fontSize: "14px" }}>SIOS</div>
          </Link>
          <Link
            to="https://shopping.startupitalia.eu/"
            target="_blank"
            style={{ color: "inherit" }}
          >
            <div style={{ fontSize: "14px" }}>Shopping</div>
          </Link>
          <Link to="/agenda/" style={{ color: "inherit" }}>
            <div style={{ fontSize: "14px" }}>Agenda</div>
          </Link>
          <Link to="/bandi/" style={{ color: "inherit" }}>
            <div style={{ fontSize: "14px" }}>Bandi</div>
          </Link>
          <Link to="/lavora-con-noi/" style={{ color: "inherit" }}>
            <div style={{ fontSize: "14px" }}>Lavora con noi</div>
          </Link>

          {/* <div style={{marginLeft: "45px", marginTop: "10px"}}><div style={{fontSize: "14px"}}>Press Kit</div></div> */}
        </div>

        <div className="site-footer-section">
          <div>
            <h2 style={{ fontSize: "17px" }}>In nostro team di 600 autori</h2>
          </div>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {users && users.nodes && users.nodes.length
              ? users.nodes.slice(0, 16).map((user, index) =>
                  index !== 15 ? (
                    <div key={user.name}>
                      <Link to={`/author/${user?.slug ? user?.slug : ""}`}>
                        <div
                          style={{
                            height: "44px",
                            width: "44px",
                            marginRight: "1rem",
                            marginBottom: "1rem",
                            backgroundSize: "cover",
                            backgroundImage:
                              "url(" +
                              ((user.avatar.url || "").includes(
                                "secure.gravatar.com"
                              )
                                ? "/img/logo-startupitalia-rocket2x.png"
                                : user.avatar.url) +
                              ")",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center center",
                          }}
                          alt=""
                        ></div>
                      </Link>
                    </div>
                  ) : (
                    <Link key="authors" to={`/authors`}>
                      <div
                        style={{
                          height: "44px",
                          width: "44px",
                          marginRight: "1rem",
                          marginBottom: "1rem",
                          backgroundSize: "cover",
                          backgroundImage:
                            'url("/img/icon_small_forward@2x.png")',
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center center",
                        }}
                        src={"/img/icon_small_forward@2x.png"}
                        alt=""
                      ></div>
                    </Link>
                  )
                )
              : null}
          </div>
        </div>
      </div>
      {/* ----------------------------------------------- MOBILE -------------------------------------------------------- */}
      <div className="show_mobile">
        <div className="site-footer-s1" style={{ marginTop: "50px" }}>
          <div style={{ display: "flex" }}>
            <img
              style={{
                margin: "auto",
                verticalAlign: "middle",
                objectFit: "contain",
                objectPosition: "left",
                height: "auto",
                maxHeight: "100px",
                display: "inline-block",
              }}
              src={"/img/logo-startupitalia-rocket.png"}
              alt={"Home"}
            />
          </div>

          <div
            style={{
              display: "flex",
              height: "50px",
              textAlign: "center",
              marginTop: "30px",
              marginBottom: "30px",
            }}
          >
            <div
              style={{
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <a
                className="resp-sharing-button__link"
                href={"https://www.facebook.com/StartupItalia.eu/"}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <div className="resp-sharing-button resp-sharing-button--facebook resp-sharing-button--medium">
                  <div
                    aria-hidden="true"
                    className="resp-sharing-button__icon resp-sharing-button__icon--solid"
                  >
                    <img alt="" src={"/img/facebook@2x-red.png"} />
                  </div>
                </div>
              </a>

              <a
                className="resp-sharing-button__link"
                href={"https://twitter.com/startup_italia"}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Twitter"
              >
                <div className="resp-sharing-button resp-sharing-button--twitter resp-sharing-button--medium">
                  <div
                    aria-hidden="true"
                    className="resp-sharing-button__icon resp-sharing-button__icon--solid"
                  >
                    <img alt="" src={"/img/twitter@2x-red.png"} />
                  </div>
                </div>
              </a>

              <a
                className="resp-sharing-button__link"
                href={"https://www.instagram.com/startupitalia/"}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <div className="resp-sharing-button resp-sharing-button--instagram resp-sharing-button--medium">
                  <div
                    aria-hidden="true"
                    className="resp-sharing-button__icon resp-sharing-button__icon--solid"
                  >
                    <img alt="" src={"/img/instagram@2x-red.png"} />
                  </div>
                </div>
              </a>

              <a
                className="resp-sharing-button__link"
                href={
                  "https://www.linkedin.com/company/startupitalia-pushtostart/"
                }
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Linkedin"
              >
                <div className="resp-sharing-button resp-sharing-button--linkedin resp-sharing-button--medium">
                  <div
                    aria-hidden="true"
                    className="resp-sharing-button__icon resp-sharing-button__icon--solid"
                  >
                    <img alt="" src={"/img/linkedin@2x-red.png"} />
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>

        <div
          style={{
            background: "rgba(194,209,217,0.5)",
            height: "1px",
            width: "100%",
          }}
        ></div>

        <div className="site-footer-s3">
          <div style={{ marginLeft: "15px" }}>
            <h2 style={{ fontSize: "17px" }}>&nbsp; {/* Topic */}</h2>
          </div>
          <Link to="/life/" style={{ color: "inherit" }}>
            <div style={{ fontSize: "14px", marginLeft: "45px" }}>Life</div>
          </Link>
          <Link to="/valoreresponsabile/" style={{ color: "inherit" }}>
            <div style={{ fontSize: "14px", marginLeft: "45px" }}>
              Valore Responsabile
            </div>
          </Link>
          <Link to="/smartmoney/" style={{ color: "inherit" }}>
            <div
              style={{
                fontSize: "14px",
                marginLeft: "45px",
                marginBottom: "15px",
              }}
            >
              Smart Money
            </div>
          </Link>
        </div>

        <div
          style={{
            background: "rgba(194,209,217,0.5)",
            height: "1px",
            width: "100%",
          }}
        ></div>

        <div className="site-footer-s2">
          <div
            style={{
              background: "rgba(194,209,217,0.5)",
              height: "1px",
              width: "100%",
            }}
          ></div>
          <div style={{ marginLeft: "15px" }}>
            <h2 style={{ fontSize: "17px" }}>&nbsp; {/* Canali */}</h2>
          </div>
          <Link to="/tech/" style={{ color: "inherit" }}>
            <div style={{ fontSize: "14px", marginLeft: "45px" }}>Tech</div>
          </Link>
          <Link to="/economy/" style={{ color: "inherit" }}>
            <div style={{ fontSize: "14px", marginLeft: "45px" }}>Economy</div>
          </Link>
          <Link to="/education/" style={{ color: "inherit" }}>
            <div style={{ fontSize: "14px", marginLeft: "45px" }}>
              Education
            </div>
          </Link>
          <Link to="/lifestyle/" style={{ color: "inherit" }}>
            <div style={{ fontSize: "14px", marginLeft: "45px" }}>
              Lifestyle
            </div>
          </Link>
          <Link to="/startup/" style={{ color: "inherit" }}>
            <div style={{ fontSize: "14px", marginLeft: "45px" }}>Startup</div>
          </Link>
          <Link to="/impact/" style={{ color: "inherit" }}>
            <div
              style={{
                fontSize: "14px",
                marginLeft: "45px",
                marginBottom: "15px",
              }}
            >
              Impact
            </div>
          </Link>
        </div>

        <div className="site-footer-s4">
          <div style={{ marginLeft: "15px" }}>
            <h2 style={{ fontSize: "17px" }}>StartupItalia</h2>
          </div>
          <Link to="/about-us/" style={{ color: "inherit" }}>
            <div style={{ fontSize: "14px", marginLeft: "45px" }}>
              Advisory Board
            </div>
          </Link>
          <a
            href={"https://investor.startupitalia.eu/"}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "inherit" }}
          >
            <div
              style={{
                fontSize: "14px",
                marginLeft: "45px",
              }}
            >
              Area Investor
            </div>
          </a>
          {/* <div style={{marginLeft: "45px", marginTop: "10px"}}><div style={{fontSize: "14px"}}>Press Kit</div></div> */}
        </div>
        <Link to="/lavora-con-noi/" style={{ color: "inherit" }}>
          <div
            style={{
              fontSize: "14px",
              marginLeft: "45px",
              marginBottom: "15px",
            }}
          >
            Lavora con noi
          </div>
        </Link>

        <div
          style={{
            background: "rgba(194,209,217,0.5)",
            height: "1px",
            width: "100%",
          }}
        ></div>

        <div className="site-footer-s5">
          <Link to="/agenda/" style={{ color: "inherit" }}>
            <h2 style={{ fontSize: "17px", marginLeft: "15px" }}>Agenda</h2>
          </Link>
          <div
            style={{
              background: "rgba(194,209,217,0.5)",
              height: "1px",
              width: "100%",
            }}
          ></div>
          <Link to="/bandi/" style={{ color: "inherit" }}>
            <h2 style={{ fontSize: "17px", marginLeft: "15px" }}>Bandi</h2>
          </Link>
          <div
            style={{
              background: "rgba(194,209,217,0.5)",
              height: "1px",
              width: "100%",
            }}
          ></div>
          <Link to="/impact/" style={{ color: "inherit" }}>
            <h2 style={{ fontSize: "17px", marginLeft: "15px" }}>Impact</h2>
          </Link>
        </div>

        <div
          style={{
            background: "rgba(194,209,217,0.5)",
            height: "1px",
            width: "100%",
          }}
        ></div>

        <div className="site-footer-s6">
          <div style={{ marginLeft: "15px" }}>
            <h2 style={{ fontSize: "17px" }}>In nostro team di 600 autori</h2>
          </div>
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {users && users.nodes && users.nodes.length
              ? users.nodes.slice(0, 6).map((user, index) =>
                  index !== 5 ? (
                    <div key={user.name}>
                      <Link to={`/author/${user?.slug ? user?.slug : ""}`}>
                        <div
                          style={{
                            height: "44px",
                            width: "44px",
                            marginRight: "1rem",
                            marginBottom: "1rem",
                            backgroundSize: "cover",
                            backgroundImage:
                              "url(" +
                              ((user.avatar.url || "").includes(
                                "secure.gravatar.com"
                              )
                                ? "/img/logo-startupitalia-rocket2x.png"
                                : user.avatar.url) +
                              ")",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center center",
                          }}
                          alt=""
                        ></div>
                      </Link>
                    </div>
                  ) : (
                    <Link key="authors" to={`/authors`}>
                      <div
                        style={{
                          height: "44px",
                          width: "44px",
                          marginRight: "1rem",
                          marginBottom: "1rem",
                          backgroundSize: "cover",
                          backgroundImage:
                            'url("/img/icon_small_forward@2x.png")',
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center center",
                        }}
                        src={"/img/icon_small_forward@2x.png"}
                        alt=""
                      ></div>
                    </Link>
                  )
                )
              : null}
          </div>
        </div>
      </div>
      <div
        style={{
          background: "rgba(194,209,217,0.5)",
          height: "1px",
          width: "100%",
          marginTop: "50px",
        }}
      ></div>
      <div
        style={{
          marginTop: "50px",
          marginLeft: "15px",
          marginRight: "15px",
          fontSize: "14px",
          textAlign: "center",
        }}
      >
        StartupItalia! è una testata registrata presso il tribunale di Roma n.
        167/2012 Direttore responsabile Anna Chiara Gaudenzi
      </div>
      <div
        style={{
          marginLeft: "15px",
          marginRight: "15px",
          fontSize: "14px",
          textAlign: "center",
        }}
      >
        StartupItalia! SRL, Cagliari, Via San Lucifero 65, 09125, PIVA
        13733231008, REA - CA - 352408, Capitale Sociale: € 28.924,60, PEC
        startupitalia@legalmail.it
      </div>
      <div
        style={{
          fontSize: "14px",
          textAlign: "center",
          marginTop: "10px",
          marginBottom: "150px",
          color: "black",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <a className="cookie-privacy-item" href="/privacy">
          <div style={{ textAlign: "right", fontWeight: "900" }}>
            Privacy&nbsp;
          </div>
        </a>
        |
        <a className="cookie-privacy-item" href="/cookie-declaration">
          <div style={{ textAlign: "left", fontWeight: "900" }}>
            &nbsp;Cookie&nbsp;
          </div>
        </a>
        |
        <div
          dangerouslySetInnerHTML={{
            __html: `
          <a class="cookie-privacy-item" href="#" style="font-weight: 900;" onclick="if(window.__lxG__consent__!==undefined&&window.__lxG__consent__.getState()!==null){window.__lxG__consent__.showConsent()} else {alert('This function only for users from European Economic Area (EEA)')}; return false">&nbsp;Change privacy settings</a>
          `,
          }}
        />
      </div>
      <div className="site-info"></div>
    </footer>
  );
}

export default Footer
